import { Button, Grid, TextField, Typography } from "@material-ui/core";
import React from "react";
import "./dashboardStyle.css";
import FilterTemplate from "./SidebarDrawer/FilterTemplate";
import ArrowForwardIcon from "@material-ui/icons/ArrowForward";

function TopVeiwForDashBoard({
  // filterData,
  // fromDate,
  // setFromDate,
  // toDate,
  // setTodate,
  // handleSubmitFilter,
  // redirectionHndler,
  // title,
  // redairectionShowBtn,
  // ShowDateFilter,
  TopViewData,
}) {
  return (
    <Grid>
      <Grid className="containerDashboard">
        <Grid className="containerHeader">
          <Typography>
            <h1 className="titleDashboard">{TopViewData.title}</h1>
          </Typography>
        </Grid>

        <Grid>
          <div className="containerFilter">
            {TopViewData.ShowDateFilter && (
              <>
                <div>
                  <TextField
                    value={TopViewData.fromDate}
                    onChange={(e) => TopViewData.setFromDate(e.target.value)}
                    type="date"
                    variant="outlined"
                    margin="dense"
                    placeholder="From date"
                    style={{ background: "#fff" }}
                  />
                </div>
                <div>
                  <TextField
                    value={TopViewData.toDate}
                    onChange={(e) => TopViewData.setTodate(e.target.value)}
                    type="date"
                    variant="outlined"
                    margin="dense"
                    placeholder="To Date"
                    style={{ background: "#fff" }}
                  />
                </div>{" "}
              </>
            )}

            {/* {TopViewData.filterData &&
              TopViewData.filterData.length > 0 &&
              TopViewData.filterData.map((filter, index) => ( */}
            {TopViewData.autocompleteFilter && (
              <div>
                <FilterTemplate filterData={TopViewData.filterData} />
              </div>
            )}
            {/* ))} */}
            <div>
              <Button
                size="small"
                variant="contained"
                style={{ whiteSpace: "nowrap" }}
                onClick={TopViewData.handleSubmitFilter}
              >
                Submit
              </Button>
            </div>
            {TopViewData.redairectionShowBtn && (
              <div>
                <Button
                  size="small"
                  onClick={TopViewData.redirectionHndler}
                  style={{ whiteSpace: "nowrap" }}
                  variant="contained"
                >
                  Fuel Dashboard 2 <ArrowForwardIcon />
                </Button>
              </div>
            )}
          </div>
        </Grid>
      </Grid>
    </Grid>
  );
}

export default TopVeiwForDashBoard;
